"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TrackingIdEnum;
(function (TrackingIdEnum) {
    TrackingIdEnum["sessionIdKey"] = "session_id";
    TrackingIdEnum["longTermIdKey"] = "long_term_id";
    TrackingIdEnum["planningIdKey"] = "planning_id";
    TrackingIdEnum["ipexIdKey"] = "ipex_id";
})(TrackingIdEnum || (TrackingIdEnum = {}));
exports.default = TrackingIdEnum;
//# sourceMappingURL=TrackingIdEnum.js.map